import react from "react";
import { useRouteError } from "react-router";
const Error = ()=>{
    return <>
        Opps!!!
        sOMETHING WENT wrong                                    
    </>
}
export default Error;